import { render, staticRenderFns } from "./EditTransportationDocumentPage.vue?vue&type=template&id=22962c0d&scoped=true"
import script from "./EditTransportationDocumentPage.vue?vue&type=script&lang=js"
export * from "./EditTransportationDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22962c0d",
  null
  
)

export default component.exports